import { VueReCaptcha } from 'vue-recaptcha-v3';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueReCaptcha, {
        siteKey:"6LdPrlkpAAAAAN_SqFVuvOd38cTBasfor21YYyQj",
        loaderOptions: {
            autoHideBadge: true,
            explicitRenderParameters: {
                badge: 'bottomleft',
            },
        },
    });
});

//Secret Key: 6LdPrlkpAAAAAC2oEEq89C0DF4nxmlbSZRk-CGNk